import { useEffect, useState } from 'react';

export default function useGetImageUrl(base64OrFile?: string | File, mimeType = 'image/jpeg') {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!base64OrFile) {
      setUrl(null);
      return;
    }

    let canceled = false;

    const createUrl = async () => {
      let blob: Blob;

      if (typeof base64OrFile === 'string') {
        // Base64 → Blob via fetch (fonctionne même pour gros fichiers)
        const dataUrl = base64OrFile.startsWith('data:')
          ? base64OrFile
          : `data:${mimeType};base64,${base64OrFile}`;
        blob = await (await fetch(dataUrl)).blob();
      } else {
        blob = base64OrFile;
      }

      if (!canceled) {
        const objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      }
    };

    createUrl();

    return () => {
      canceled = true;
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  // On ne met pas url dans les dépendances sinon boucle infinie
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base64OrFile, mimeType]);

  return url;
}